import PropTypes from 'prop-types'
import React, {useState} from 'react';
import styles from './CollapsibleActionBar.module.scss';

/**
 *
 * @param show
 * @param title
 * @param children
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function CollapsibleActionBar({ floatLeft = false, children, title, className, moveX })  {
    const [ showPanel, setShowPanel ] = useState(false)

    const handleShowPanel = () => {
        setShowPanel(!showPanel)
    }
    const styleObj = { right: 0}
    if (moveX) {
        styleObj.right = moveX
    }
    console.log(styleObj)
    return (
        <div style={styleObj} className={`${floatLeft ? styles.floatLeft : ''} ${styles.CollapsibleActionBar} ${className} ${showPanel ? styles.open: ''}`}>
            <div className={`${styles.hiddenTab}`} onClick={handleShowPanel}>
                <div className={`${styles.hiddenTabButton}`} href="#">
                    <span>{title}</span>
                </div>
            </div>
            {children}
        </div>
    )

}

export default CollapsibleActionBar;

CollapsibleActionBar.propTypes = {
  children: PropTypes.any,
  rest: PropTypes.any,
  show: PropTypes.bool,
  title: PropTypes.string
}

CollapsibleActionBar.defaultProps = {
  show: false,
  title: ''
}
